import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as withdrawApi from '../../api/withdraw';
import { message } from 'antd';

// 获取提现申请列表
export const fetchWithdrawApplications = createAsyncThunk(
  'withdraw/fetchWithdrawApplications',
  async (params, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.getWithdrawApplicationList(params);
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取提现申请列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取提现申请列表失败');
    }
  }
);

// 获取提现申请详情
export const fetchWithdrawApplicationDetail = createAsyncThunk(
  'withdraw/fetchWithdrawApplicationDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.getWithdrawApplicationDetail(id);
      if (response && response.code === 200) {
        return response.data;
      }
      return rejectWithValue(response?.message || '获取提现申请详情失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取提现申请详情失败');
    }
  }
);

// 审核提现申请
export const reviewWithdrawApplication = createAsyncThunk(
  'withdraw/reviewWithdrawApplication',
  async ({ id, status, rejectReason }, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.reviewWithdrawApplication(id, { status, rejectReason });
      if (response && response.code === 200) {
        message.success('审核提现申请成功');
        return response.data;
      }
      message.error(response?.message || '审核提现申请失败');
      return rejectWithValue(response?.message || '审核提现申请失败');
    } catch (error) {
      message.error(error.message || '审核提现申请失败');
      return rejectWithValue(error.message || '审核提现申请失败');
    }
  }
);

// 处理提现转账
export const processWithdrawTransfer = createAsyncThunk(
  'withdraw/processWithdrawTransfer',
  async ({ id, status, proofUrl, channelOrderNo }, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.processWithdrawTransfer(id, { status, proofUrl, channelOrderNo });
      if (response && response.code === 200) {
        message.success('处理提现转账成功');
        return response.data;
      }
      message.error(response?.message || '处理提现转账失败');
      return rejectWithValue(response?.message || '处理提现转账失败');
    } catch (error) {
      message.error(error.message || '处理提现转账失败');
      return rejectWithValue(error.message || '处理提现转账失败');
    }
  }
);

// ========== 提现配置相关 ==========

// 分页查询全局提现配置
export const fetchWithdrawConfigPage = createAsyncThunk(
  'withdraw/fetchWithdrawConfigPage',
  async (params, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.getWithdrawConfigPage(params);
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取提现配置列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取提现配置列表失败');
    }
  }
);

// 根据账户类型查询提现配置
export const fetchWithdrawConfigByAccountType = createAsyncThunk(
  'withdraw/fetchWithdrawConfigByAccountType',
  async (accountType, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.getWithdrawConfigByAccountType(accountType);
      if (response && response.code === 200) {
        return response.data;
      }
      return rejectWithValue(response?.message || '获取提现配置失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取提现配置失败');
    }
  }
);

// 创建全局提现配置
export const createWithdrawConfig = createAsyncThunk(
  'withdraw/createWithdrawConfig',
  async (data, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.createWithdrawConfig(data);
      if (response && response.code === 200) {
        message.success('创建提现配置成功');
        return response.data;
      }
      message.error(response?.message || '创建提现配置失败');
      return rejectWithValue(response?.message || '创建提现配置失败');
    } catch (error) {
      message.error(error.message || '创建提现配置失败');
      return rejectWithValue(error.message || '创建提现配置失败');
    }
  }
);

// 更新全局提现配置
export const updateWithdrawConfig = createAsyncThunk(
  'withdraw/updateWithdrawConfig',
  async ({ configId, data }, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.updateWithdrawConfig(configId, data);
      if (response && response.code === 200) {
        message.success('更新提现配置成功');
        return { configId, data: response.data };
      }
      message.error(response?.message || '更新提现配置失败');
      return rejectWithValue(response?.message || '更新提现配置失败');
    } catch (error) {
      message.error(error.message || '更新提现配置失败');
      return rejectWithValue(error.message || '更新提现配置失败');
    }
  }
);

// 删除全局提现配置
export const deleteWithdrawConfig = createAsyncThunk(
  'withdraw/deleteWithdrawConfig',
  async (configId, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.deleteWithdrawConfig(configId);
      if (response && response.code === 200) {
        message.success('删除提现配置成功');
        return configId;
      }
      message.error(response?.message || '删除提现配置失败');
      return rejectWithValue(response?.message || '删除提现配置失败');
    } catch (error) {
      message.error(error.message || '删除提现配置失败');
      return rejectWithValue(error.message || '删除提现配置失败');
    }
  }
);

// ========== 用户提现配置相关 ==========

// 分页查询用户提现配置
export const fetchUserWithdrawConfigPage = createAsyncThunk(
  'withdraw/fetchUserWithdrawConfigPage',
  async (params, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.getUserWithdrawConfigPage(params);
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取用户提现配置列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取用户提现配置列表失败');
    }
  }
);

// 根据用户ID查询提现配置
export const fetchUserWithdrawConfigsByUserId = createAsyncThunk(
  'withdraw/fetchUserWithdrawConfigsByUserId',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.getUserWithdrawConfigsByUserId(userId);
      if (response && response.code === 200) {
        return response.data;
      }
      return rejectWithValue(response?.message || '获取用户提现配置失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取用户提现配置失败');
    }
  }
);

// 为用户创建提现配置
export const createUserWithdrawConfig = createAsyncThunk(
  'withdraw/createUserWithdrawConfig',
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.createUserWithdrawConfig(userId, data);
      if (response && response.code === 200) {
        message.success('创建用户提现配置成功');
        return response.data;
      }
      message.error(response?.message || '创建用户提现配置失败');
      return rejectWithValue(response?.message || '创建用户提现配置失败');
    } catch (error) {
      message.error(error.message || '创建用户提现配置失败');
      return rejectWithValue(error.message || '创建用户提现配置失败');
    }
  }
);

// 更新用户提现配置
export const updateUserWithdrawConfig = createAsyncThunk(
  'withdraw/updateUserWithdrawConfig',
  async ({ configId, data }, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.updateUserWithdrawConfig(configId, data);
      if (response && response.code === 200) {
        message.success('更新用户提现配置成功');
        return { configId, data: response.data };
      }
      message.error(response?.message || '更新用户提现配置失败');
      return rejectWithValue(response?.message || '更新用户提现配置失败');
    } catch (error) {
      message.error(error.message || '更新用户提现配置失败');
      return rejectWithValue(error.message || '更新用户提现配置失败');
    }
  }
);

// 删除用户提现配置
export const deleteUserWithdrawConfig = createAsyncThunk(
  'withdraw/deleteUserWithdrawConfig',
  async (configId, { rejectWithValue }) => {
    try {
      const response = await withdrawApi.deleteUserWithdrawConfig(configId);
      if (response && response.code === 200) {
        message.success('删除用户提现配置成功');
        return configId;
      }
      message.error(response?.message || '删除用户提现配置失败');
      return rejectWithValue(response?.message || '删除用户提现配置失败');
    } catch (error) {
      message.error(error.message || '删除用户提现配置失败');
      return rejectWithValue(error.message || '删除用户提现配置失败');
    }
  }
);

// 初始状态
const initialState = {
  withdrawApplicationList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    error: null,
    searchParams: {
      userId: undefined,
      orderNo: '',
      withdrawStatus: undefined,
      withdrawType: undefined,
      minAmount: undefined,
      maxAmount: undefined,
      username: '',
      nickname: '',
      startTime: undefined,
      endTime: undefined
    }
  },
  withdrawApplicationDetail: {
    data: null,
    loading: false,
    error: null
  },
  reviewStatus: {
    loading: false,
    success: false,
    error: null
  },
  transferStatus: {
    loading: false,
    success: false,
    error: null
  },
  // 提现配置相关状态
  withdrawConfigList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    error: null
  },
  withdrawConfigByAccountType: {
    data: null,
    loading: false,
    error: null
  },
  configOperationStatus: {
    loading: false,
    success: false,
    error: null
  },
  // 用户提现配置相关状态
  userWithdrawConfigList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    error: null
  },
  userWithdrawConfigsByUserId: {
    data: [],
    loading: false,
    error: null
  },
  userConfigOperationStatus: {
    loading: false,
    success: false,
    error: null
  }
};

// 创建slice
const withdrawSlice = createSlice({
  name: 'withdraw',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.withdrawApplicationList.searchParams = {
        ...state.withdrawApplicationList.searchParams,
        ...action.payload
      };
    },
    resetSearchParams: (state) => {
      state.withdrawApplicationList.searchParams = {
        userId: undefined,
        orderNo: '',
        withdrawStatus: undefined,
        withdrawType: undefined,
        minAmount: undefined,
        maxAmount: undefined,
        username: '',
        nickname: '',
        startTime: undefined,
        endTime: undefined
      };
    },
    clearReviewStatus: (state) => {
      state.reviewStatus = {
        loading: false,
        success: false,
        error: null
      };
    },
    clearTransferStatus: (state) => {
      state.transferStatus = {
        loading: false,
        success: false,
        error: null
      };
    },
    clearConfigOperationStatus: (state) => {
      state.configOperationStatus = {
        loading: false,
        success: false,
        error: null
      };
    },
    clearUserConfigOperationStatus: (state) => {
      state.userConfigOperationStatus = {
        loading: false,
        success: false,
        error: null
      };
    }
  },
  extraReducers: (builder) => {
    builder
      // 处理获取提现申请列表
      .addCase(fetchWithdrawApplications.pending, (state) => {
        state.withdrawApplicationList.loading = true;
        state.withdrawApplicationList.error = null;
      })
      .addCase(fetchWithdrawApplications.fulfilled, (state, action) => {
        state.withdrawApplicationList.loading = false;
        state.withdrawApplicationList.data = action.payload.data.records || [];
        state.withdrawApplicationList.total = action.payload.data.total || 0;
        
        // 使用传入的page和size参数更新状态，而不是依赖后端返回的值
        if (action.payload.params) {
          if (action.payload.params.page) {
            state.withdrawApplicationList.current = action.payload.params.page;
          } else {
            state.withdrawApplicationList.current = action.payload.data.current || 1;
          }
          
          if (action.payload.params.size) {
            state.withdrawApplicationList.size = action.payload.params.size;
          } else {
            state.withdrawApplicationList.size = action.payload.data.size || 10;
          }
        } else {
          state.withdrawApplicationList.current = action.payload.data.current || 1;
          state.withdrawApplicationList.size = action.payload.data.size || 10;
        }
        
        // 检查是否有明确传入的搜索参数，如果有则更新searchParams
        if (action.payload.params) {
          // 过滤掉page和size参数，避免将它们保存到searchParams中
          const { page, size, ...searchParams } = action.payload.params;
          
          // 如果没有传入特定的搜索参数，则不要覆盖现有的searchParams
          const hasSearchParams = Object.values(searchParams).some(value => 
            value !== undefined && value !== '' && value !== null
          );
          
          // 只有在有明确的搜索参数时才更新
          if (hasSearchParams) {
            state.withdrawApplicationList.searchParams = {
              ...state.withdrawApplicationList.searchParams,
              ...searchParams
            };
          }
        }
      })
      .addCase(fetchWithdrawApplications.rejected, (state, action) => {
        state.withdrawApplicationList.loading = false;
        state.withdrawApplicationList.error = action.payload;
      })

      // 处理获取提现申请详情
      .addCase(fetchWithdrawApplicationDetail.pending, (state) => {
        state.withdrawApplicationDetail.loading = true;
        state.withdrawApplicationDetail.error = null;
      })
      .addCase(fetchWithdrawApplicationDetail.fulfilled, (state, action) => {
        state.withdrawApplicationDetail.loading = false;
        state.withdrawApplicationDetail.data = action.payload;
      })
      .addCase(fetchWithdrawApplicationDetail.rejected, (state, action) => {
        state.withdrawApplicationDetail.loading = false;
        state.withdrawApplicationDetail.error = action.payload;
      })

      // 处理审核提现申请
      .addCase(reviewWithdrawApplication.pending, (state) => {
        state.reviewStatus.loading = true;
        state.reviewStatus.success = false;
        state.reviewStatus.error = null;
      })
      .addCase(reviewWithdrawApplication.fulfilled, (state) => {
        state.reviewStatus.loading = false;
        state.reviewStatus.success = true;
      })
      .addCase(reviewWithdrawApplication.rejected, (state, action) => {
        state.reviewStatus.loading = false;
        state.reviewStatus.error = action.payload;
      })

      // 处理提现转账
      .addCase(processWithdrawTransfer.pending, (state) => {
        state.transferStatus.loading = true;
        state.transferStatus.success = false;
        state.transferStatus.error = null;
      })
      .addCase(processWithdrawTransfer.fulfilled, (state) => {
        state.transferStatus.loading = false;
        state.transferStatus.success = true;
      })
      .addCase(processWithdrawTransfer.rejected, (state, action) => {
        state.transferStatus.loading = false;
        state.transferStatus.error = action.payload;
      })

      // ========== 提现配置相关 ==========
      
      // 处理分页查询全局提现配置
      .addCase(fetchWithdrawConfigPage.pending, (state) => {
        state.withdrawConfigList.loading = true;
        state.withdrawConfigList.error = null;
      })
      .addCase(fetchWithdrawConfigPage.fulfilled, (state, action) => {
        state.withdrawConfigList.loading = false;
        state.withdrawConfigList.data = action.payload.data.records || [];
        state.withdrawConfigList.total = action.payload.data.total || 0;
        state.withdrawConfigList.current = action.payload.data.current || 1;
        state.withdrawConfigList.size = action.payload.data.size || 10;
      })
      .addCase(fetchWithdrawConfigPage.rejected, (state, action) => {
        state.withdrawConfigList.loading = false;
        state.withdrawConfigList.error = action.payload;
      })

      // 处理根据账户类型查询提现配置
      .addCase(fetchWithdrawConfigByAccountType.pending, (state) => {
        state.withdrawConfigByAccountType.loading = true;
        state.withdrawConfigByAccountType.error = null;
      })
      .addCase(fetchWithdrawConfigByAccountType.fulfilled, (state, action) => {
        state.withdrawConfigByAccountType.loading = false;
        state.withdrawConfigByAccountType.data = action.payload;
      })
      .addCase(fetchWithdrawConfigByAccountType.rejected, (state, action) => {
        state.withdrawConfigByAccountType.loading = false;
        state.withdrawConfigByAccountType.error = action.payload;
      })

      // 处理创建全局提现配置
      .addCase(createWithdrawConfig.pending, (state) => {
        state.configOperationStatus.loading = true;
        state.configOperationStatus.success = false;
        state.configOperationStatus.error = null;
      })
      .addCase(createWithdrawConfig.fulfilled, (state) => {
        state.configOperationStatus.loading = false;
        state.configOperationStatus.success = true;
      })
      .addCase(createWithdrawConfig.rejected, (state, action) => {
        state.configOperationStatus.loading = false;
        state.configOperationStatus.error = action.payload;
      })

      // 处理更新全局提现配置
      .addCase(updateWithdrawConfig.pending, (state) => {
        state.configOperationStatus.loading = true;
        state.configOperationStatus.success = false;
        state.configOperationStatus.error = null;
      })
      .addCase(updateWithdrawConfig.fulfilled, (state, action) => {
        state.configOperationStatus.loading = false;
        state.configOperationStatus.success = true;
        // 更新列表中的对应项
        const index = state.withdrawConfigList.data.findIndex(item => item.id === action.payload.configId);
        if (index !== -1) {
          state.withdrawConfigList.data[index] = {
            ...state.withdrawConfigList.data[index],
            ...action.payload.data
          };
        }
      })
      .addCase(updateWithdrawConfig.rejected, (state, action) => {
        state.configOperationStatus.loading = false;
        state.configOperationStatus.error = action.payload;
      })

      // 处理删除全局提现配置
      .addCase(deleteWithdrawConfig.pending, (state) => {
        state.configOperationStatus.loading = true;
        state.configOperationStatus.success = false;
        state.configOperationStatus.error = null;
      })
      .addCase(deleteWithdrawConfig.fulfilled, (state, action) => {
        state.configOperationStatus.loading = false;
        state.configOperationStatus.success = true;
        // 从列表中移除
        state.withdrawConfigList.data = state.withdrawConfigList.data.filter(
          item => item.id !== action.payload
        );
        state.withdrawConfigList.total = Math.max(0, state.withdrawConfigList.total - 1);
      })
      .addCase(deleteWithdrawConfig.rejected, (state, action) => {
        state.configOperationStatus.loading = false;
        state.configOperationStatus.error = action.payload;
      })

      // ========== 用户提现配置相关 ==========
      
      // 处理分页查询用户提现配置
      .addCase(fetchUserWithdrawConfigPage.pending, (state) => {
        state.userWithdrawConfigList.loading = true;
        state.userWithdrawConfigList.error = null;
      })
      .addCase(fetchUserWithdrawConfigPage.fulfilled, (state, action) => {
        state.userWithdrawConfigList.loading = false;
        state.userWithdrawConfigList.data = action.payload.data.records || [];
        state.userWithdrawConfigList.total = action.payload.data.total || 0;
        state.userWithdrawConfigList.current = action.payload.data.current || 1;
        state.userWithdrawConfigList.size = action.payload.data.size || 10;
      })
      .addCase(fetchUserWithdrawConfigPage.rejected, (state, action) => {
        state.userWithdrawConfigList.loading = false;
        state.userWithdrawConfigList.error = action.payload;
      })

      // 处理根据用户ID查询提现配置
      .addCase(fetchUserWithdrawConfigsByUserId.pending, (state) => {
        state.userWithdrawConfigsByUserId.loading = true;
        state.userWithdrawConfigsByUserId.error = null;
      })
      .addCase(fetchUserWithdrawConfigsByUserId.fulfilled, (state, action) => {
        state.userWithdrawConfigsByUserId.loading = false;
        state.userWithdrawConfigsByUserId.data = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchUserWithdrawConfigsByUserId.rejected, (state, action) => {
        state.userWithdrawConfigsByUserId.loading = false;
        state.userWithdrawConfigsByUserId.error = action.payload;
      })

      // 处理为用户创建提现配置
      .addCase(createUserWithdrawConfig.pending, (state) => {
        state.userConfigOperationStatus.loading = true;
        state.userConfigOperationStatus.success = false;
        state.userConfigOperationStatus.error = null;
      })
      .addCase(createUserWithdrawConfig.fulfilled, (state) => {
        state.userConfigOperationStatus.loading = false;
        state.userConfigOperationStatus.success = true;
      })
      .addCase(createUserWithdrawConfig.rejected, (state, action) => {
        state.userConfigOperationStatus.loading = false;
        state.userConfigOperationStatus.error = action.payload;
      })

      // 处理更新用户提现配置
      .addCase(updateUserWithdrawConfig.pending, (state) => {
        state.userConfigOperationStatus.loading = true;
        state.userConfigOperationStatus.success = false;
        state.userConfigOperationStatus.error = null;
      })
      .addCase(updateUserWithdrawConfig.fulfilled, (state, action) => {
        state.userConfigOperationStatus.loading = false;
        state.userConfigOperationStatus.success = true;
        // 更新列表中的对应项
        const index = state.userWithdrawConfigList.data.findIndex(item => item.id === action.payload.configId);
        if (index !== -1) {
          state.userWithdrawConfigList.data[index] = {
            ...state.userWithdrawConfigList.data[index],
            ...action.payload.data
          };
        }
      })
      .addCase(updateUserWithdrawConfig.rejected, (state, action) => {
        state.userConfigOperationStatus.loading = false;
        state.userConfigOperationStatus.error = action.payload;
      })

      // 处理删除用户提现配置
      .addCase(deleteUserWithdrawConfig.pending, (state) => {
        state.userConfigOperationStatus.loading = true;
        state.userConfigOperationStatus.success = false;
        state.userConfigOperationStatus.error = null;
      })
      .addCase(deleteUserWithdrawConfig.fulfilled, (state, action) => {
        state.userConfigOperationStatus.loading = false;
        state.userConfigOperationStatus.success = true;
        // 从列表中移除
        state.userWithdrawConfigList.data = state.userWithdrawConfigList.data.filter(
          item => item.id !== action.payload
        );
        state.userWithdrawConfigList.total = Math.max(0, state.userWithdrawConfigList.total - 1);
      })
      .addCase(deleteUserWithdrawConfig.rejected, (state, action) => {
        state.userConfigOperationStatus.loading = false;
        state.userConfigOperationStatus.error = action.payload;
      });
  }
});

export const { setSearchParams, resetSearchParams, clearReviewStatus, clearTransferStatus, clearConfigOperationStatus, clearUserConfigOperationStatus } = withdrawSlice.actions;

export default withdrawSlice.reducer; 